export {getBracketSliderStep} from 'features/financial-products';
